import * as React from "react";

interface NavigationTabProps {
  route: string;
  selectedContentRoute: string;
  onUserWantsToSelectContentRoute: (contentRoute: string) => void;
}

export const NavigationTab: React.FunctionComponent<NavigationTabProps> = (
  props
) => {
  const onClick = () => {
    props.onUserWantsToSelectContentRoute(props.route);
  };

  return (
    <div
      className={`navigation-tab route-${props.route} ${
        props.selectedContentRoute === props.route ? "active" : "inactive"
      }`}
      onClick={onClick}
    ></div>
  );
};
